const DOMAIN_NAME = 'roles';
const ROWS_PER_PAGE = 10;
const All_ROLE_ROUTE = 13;
export { DOMAIN_NAME, All_ROLE_ROUTE, ROWS_PER_PAGE };

